Vue.component('ack-curo-resins', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-curo-resins',
	mixins: [languageMixins],
	created() {},
	mounted() {
		appLog.log('ack-curo-resins mounted');
		//this.setPageIsLoading(false)
	},
	props: {},
	computed: {
		...Vuex.mapGetters('articles', ['articlesArray']),
		...Vuex.mapGetters('resins', ['selectedShopifyProduct']),
		...Vuex.mapState('resins', ['selectedProductId']),
		...Vuex.mapGetters('localization', ['isUS_CA']),
		lastArticles() {
			let arr = [];
			for (let index = 0; index < 3; index++) {
				const element = this.articlesArray[index];
				arr.push(element);
			}
			return arr;
		},
		isMobile() {
			return this.$parent.isMobile;
		},
		productMenuItems() {
			const hideCuroModel = (resin) => resin.id !== 'model';
			const defaultItems = this.curoResinsInfo.product_menu_section.menu_items;
			const usCaItems = defaultItems.filter(hideCuroModel);
			return this.isUS_CA ? usCaItems : defaultItems;
		},
	},
	data() {
		return {
			pageId: 'resins',
			default_3dps_bundle: 'shop-3dps-6',
			curoResinsInfo: {
				title_section: {
					id: 'curo',
					title: 'resins.main_title',
					subtitle: 'resins.main_title',
					title_img:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Logo_Resize-08.png?v=1705913619',
					description: 'resins.main_description',
					image_desktop:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Website-V4.0-Resins_banner_5b066cdf-7e5d-450c-b8ad-40ad2af16d4c.jpg?v=1707991590',
					image_mobile: null,
					price: 0.0,
					shop_button: 'resins.shop_button',
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
				},
				icons_section: {
					collateral_items: [
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/UVBox_V4_icon_1.png?v=1702274298',
							title: 'Flyer',
							// link: 'https://cdn.ackuretta.com/downloads/curo/CURO_Flyer_Digital.pdf?v=latest',
							link: 'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/curo/CURO_Flyer_Digital.pdf',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_icon_1Catalog.png?v=1705041558',
							title: 'Booklet',
							// link: 'https://cdn.ackuretta.com/public/curo/Digital_Application%20Booklet.pdf',
							link: 'https://s3.us-east-1.amazonaws.com/ackuretta.website/public/curo/Digital_Application+Booklet.pdf',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_icon_3IFU.png?v=1705041558',
							title: 'CURO IFU',
							link: 'https://cdn.ackuretta.com/downloads/curo/Instructions%20for%20Use.pdf',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_icon_5Shipping.png?v=1705041558',
							title: 'Shipping Restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
						},
					],
				},
				product_menu_section: {
					menu_items: [
						{
							imageMenu:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Application_icon_1_Model_Ortho_option2.png?v=1707986540',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_16.png?v=1707831270',
							id: 'ortho-label',
							productId: '6893565673575',
							link: '#ortho',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_1%20Model%20Element.png',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_1.png?v=1705482112',
							id: 'element',
							productId: '6627069591655',
							link: '#element',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_2%20Model.png',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_2.png?v=1705482112',
							id: 'model',
							productId: '6624780812391',
							link: '#model',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_4%20Splint.png',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_4.png?v=1705482113',
							id: 'splint',
							productId: '6627062448231',
							link: '#splint',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_3%20Crown.png',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_3_f73ca71a-c353-413b-8415-9cd6e07f37d8.png?v=1706181465',
							id: 'crown',
							productId: '6627055435879',
							link: '#crown',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_5%20Denture.png',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_5.png?v=1705482112',
							id: 'pro-denture',
							productId: '6624785760359',
							link: '#pro-denture',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_6%20Guide.png',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_6.png?v=1705482599',
							id: 'guide',
							productId: '6624785924199',
							link: '#guide',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_8%20Tray.png',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_8.png?v=1705482113',
							id: 'tray',
							productId: '6627069427815',
							link: '#tray',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_9%20IBT.png',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_9.png?v=1705482112',
							id: 'ibt',
							productId: '6600052015207',
							link: '#ibt',
						},
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_7%20Cast.png?v=latest',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_7.png?v=1705482112',
							id: 'pro-cast',
							productId: '6626529214567',
							link: '#pro-cast',
						},
						// { imageMenu: 'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_10%20Gingiva.png', imageLogo: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_10.png?v=1705482112', id: 'gingiva', productId: "6627058712679", link: '#gingiva' }
						{
							imageMenu:
								'https://cdn.ackuretta.com/public/new/website/assets/resins/Resin_V4_Application%20icon_10%20Gingiva.png',
							imageLogo:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Circle_11.png?v=1736219465',
							id: 'pro-gingiva',
							productId: '7186312757351',
							link: '#pro-gingiva',
						},
					],
				},
				articles: null,
				testimonials_section: {
					testimonial_items: [
						{
							id: 1,
							name: 'resins.testimonials_section.testimonial_items.testimonial_one.name',
							title: 'resins.testimonials_section.testimonial_items.testimonial_one.title',
							quote: 'resins.testimonials_section.testimonial_items.testimonial_one.description',
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/KOL_Testimonials_Adam_Nulty.jpg?v=1705894661',
							altText: 'First slide',
						},
						{
							id: 2,
							name: 'resins.testimonials_section.testimonial_items.testimonial_two.name',
							title: 'resins.testimonials_section.testimonial_items.testimonial_two.title',
							quote: 'resins.testimonials_section.testimonial_items.testimonial_two.description',
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/KOL_Testimonials_-Juliana_Andre.jpg?v=1703825729',
							altText: 'Second slide',
						},
						{
							id: 3,
							name: 'resins.testimonials_section.testimonial_items.testimonial_three.name',
							title: 'resins.testimonials_section.testimonial_items.testimonial_three.title',
							quote: 'resins.testimonials_section.testimonial_items.testimonial_three.description',
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/stivetiang.jpg?v=1646636670',
							altText: 'Third slide',
						},
					],
				},
				media_grid_section: {
					title: 'Successful Cases',
					media_grid_collection: {
						main_item: {
							title: 'Images provided by Fermín Ocañas',
							description: '',
							img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Successful_Cases_1.jpg?v=1747380739',
						},
						secondary_item: {
							title: 'Images provided by Aleksandar Momani',
							description: '',
							img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Resin_V4_Successful_Cases_2.jpg?v=1747380739',
						},
					},
				},
			},
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		...Vuex.mapActions('resins', ['menuItemClick']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
		onResinMenuItemClick(item) {
			this.menuItemClick(item.productId);
			this.selectedProductId = item.productId;
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
